/*
  Flaire & Co. - previous / next buttons for the featured side-to-side strips
  Crowd Favorites, Shop by Collection, Bundled deals (home page) and the product rows on the collection pages (.fcr).
  - One pair of round buttons sits under each strip, at the bottom right. Works on phones and desktop.
  - Each press scrolls about one screen of products. The buttons fade out at either end, and the whole pair hides when the
    strip is short enough that there is nothing to scroll (or while its tab is not showing).
  - The older side arrows that only appeared on desktop are hidden once the new buttons are on the page (flaire-swipe.css).
  - Swiping, dragging and the keyboard keep working as before. Styles: assets/flaire-swipe.css (.fsn).
  To add another strip, add a line to TARGETS: the scrolling element, the wrapper to put the buttons after, and the heading.
*/
(function () {
  var TARGETS = [
    { scroller: '.fpc-scroll-wrap', holder: '.fpc-scroll-region', title: '.fpc-title' },
    { scroller: '.fct-scroll-wrap', holder: '.fct-scroll-region', title: '.fct-title' },
    { scroller: '.flbd-track', holder: '.flbd-scroll-outer', title: '.flbd-title' },
    { scroller: '.fcr__scroll', holder: '.fcr__region', title: '.fcr__title' }
  ];
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var LEFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><polyline points="15 18 9 12 15 6"></polyline></svg>';
  var RIGHT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><polyline points="9 18 15 12 9 6"></polyline></svg>';

  function headingFor(scroller, sel) {
    var box = scroller.closest('.fpc-wrap, .fct-wrap, .flbd-wrap, .fcr');
    var h = box && box.querySelector(sel);
    return h ? h.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function button(cls, label, icon) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'fsn__btn ' + cls;
    b.setAttribute('aria-label', label);
    b.innerHTML = icon;
    return b;
  }

  function build(scroller, holder, titleSel) {
    if (holder.getAttribute('data-fsn')) return;
    holder.setAttribute('data-fsn', '1');
    holder.classList.add('fsn-on');

    var name = headingFor(scroller, titleSel);
    var nav = document.createElement('div');
    nav.className = 'fsn';
    nav.setAttribute('role', 'group');
    nav.setAttribute('aria-label', name ? name + ' navigation' : 'Scroll navigation');
    nav.hidden = true;
    var prev = button('fsn__prev', name ? 'Previous in ' + name : 'Previous', LEFT);
    var next = button('fsn__next', name ? 'Next in ' + name : 'Next', RIGHT);
    nav.appendChild(prev);
    nav.appendChild(next);
    holder.insertAdjacentElement('afterend', nav);

    function max() { return scroller.scrollWidth - scroller.clientWidth; }
    function step() { return Math.max(scroller.clientWidth * 0.85, 160); }
    function mark(btn, off) {
      btn.setAttribute('aria-disabled', off ? 'true' : 'false');
      btn.classList.toggle('is-off', off);
    }
    function update() {
      nav.hidden = !(scroller.clientWidth > 0 && max() > 4);
      mark(prev, scroller.scrollLeft <= 2);
      mark(next, scroller.scrollLeft >= max() - 2);
    }
    function go(dir) {
      return function () {
        if ((dir < 0 ? prev : next).getAttribute('aria-disabled') === 'true') return;
        scroller.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });
      };
    }
    prev.addEventListener('click', go(-1));
    next.addEventListener('click', go(1));
    scroller.addEventListener('scroll', update, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(update).observe(scroller);
    else window.addEventListener('resize', update);
    update();
    // product photos load after the first paint and change the strip's width
    window.addEventListener('load', update);
  }

  function scan() {
    TARGETS.forEach(function (t) {
      document.querySelectorAll(t.scroller).forEach(function (scroller) {
        var holder = scroller.closest(t.holder);
        if (holder) build(scroller, holder, t.title);
      });
    });
  }

  var timer = null;
  function later() { clearTimeout(timer); timer = setTimeout(scan, 150); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', later);
  // sections that draw themselves late, or are redrawn by in-place filtering
  if (window.MutationObserver) new MutationObserver(later).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();